/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Integration } from '../../models/integration';

export interface AttachIntegration$Params {
  shop_name: string;
}

export function attachIntegration(http: HttpClient, rootUrl: string, params: AttachIntegration$Params, context?: HttpContext): Observable<StrictHttpResponse<Integration>> {
  const rb = new RequestBuilder(rootUrl, attachIntegration.PATH, 'post');
  if (params) {
    rb.path('shop_name', params.shop_name, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Integration>;
    })
  );
}

attachIntegration.PATH = '/internal/integrations/shopify/{shop_name}/attach';
